module.exports = __webpack_public_path__ + "static/media/snapshot_onboarding_and_1.3aac9994.png";